// components/slots-auto

import template   from './template.jade'

var name = 'slots-auto'

export default {

    name: name,
    template: template(),

    data: () => ({
        name: name,
    }),
}



/** WEBPACK FOOTER **
 ** ./src/js/components/slots-auto/index.js
 **/